/**
 * `platform_audit` — journal de la console (base plateforme, 4.1 ; D14).
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, idSchema, withAudit } from './commun.js';
export const ACTIONS_PLATEFORME = [
    'galerie_provisionnee',
    'galerie_suspendue',
    'galerie_resiliee',
    'domaine_ajoute',
    'domaine_verifie',
    'sauvegarde_lancee',
    'restauration_testee',
    'export_complet_lance',
    'acces_support_accorde',
    'acces_support_revoque',
    'palier_change',
    'module_ouvert',
];
export const actionPlateformeSchema = z.enum(ACTIONS_PLATEFORME);
export const CIBLES_PLATEFORME = ['gallery', 'group', 'domain', 'account', 'subscription'];
export const ciblePlateformeSchema = z.enum(CIBLES_PLATEFORME);
export const platformAuditSchema = withAudit(z.object({
    _id: idSchema,
    acteurId: idSchema,
    action: actionPlateformeSchema,
    cible: z.object({ type: ciblePlateformeSchema, id: idSchema }),
    date: z.date(),
    adresse: z.string().optional(),
    details: z.record(z.string(), z.unknown()).optional(),
}));
export const platformAuditCreationSchema = platformAuditSchema.omit(CHAMPS_DOCUMENT);
//# sourceMappingURL=platform-audit.js.map